import initialState from '../../../store/initialState';
import * as volumeTrendReportTypes from '../services/VolumeTrendActionType';

const types = { ...volumeTrendReportTypes };

const VolumeTrendReportReducer = (state = initialState.VolumeTrendReportReducer, action) => {
    switch (action.type) {


        case types.VOLUME_TREND_REQUEST:
            return { ...state, isLoadingVolumeTrend: true };
        case types.VOLUME_TREND_SUCCESS:
            return { ...state, isLoadingVolumeTrend: false, volumeTrendData: action.payload || {} };
        case types.VOLUME_TREND_FAILURE:
            return { ...state, isLoadingVolumeTrend: false, volumeTrendData: {} };

        case types.PIVOT_VOLUME_TREND_BY_ID_REQUEST:
            return { ...state, isLoadingPivotVolumeTrend: true };
        case types.PIVOT_VOLUME_TREND_BY_ID_SUCCESS:
            return { ...state, isLoadingPivotVolumeTrend: false, pivotVolumeTrendData: action.payload || {} };
        case types.PIVOT_VOLUME_TREND_BY_ID_FAILURE:
            return { ...state, isLoadingPivotVolumeTrend: false, pivotVolumeTrendData: {} };

        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_REQUEST:
            return { ...state, isLoadingUnreadPivotVolumeTrend: true };
        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SUCCESS:
            return { ...state, isLoadingUnreadPivotVolumeTrend: false, unreadPivotVolumeTrendData: action.payload || {} };
        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_FAILURE:
            return { ...state, isLoadingUnreadPivotVolumeTrend: false, unreadPivotVolumeTrendData: {} };

        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_REQUEST:
            return { ...state, isLoadingUnreadPivotVolumeTrendBySite: true };
        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_SUCCESS:
            return { ...state, isLoadingUnreadPivotVolumeTrendBySite: false, unreadPivotVolumeTrendBySiteData: action.payload || {} };
        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_FAILURE:
            return { ...state, isLoadingUnreadPivotVolumeTrendBySite: false, unreadPivotVolumeTrendBySiteData: {} };

        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_REQUEST:
            return { ...state, isLoadingUnreadPivotVolumeTrendBySitePriority: true };
        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_SUCCESS:
            return { ...state, isLoadingUnreadPivotVolumeTrendBySitePriority: false, unreadPivotVolumeTrendBySitePriorityData: action.payload || {} };
        case types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_FAILURE:
            return { ...state, isLoadingUnreadPivotVolumeTrendBySitePriority: false, unreadPivotVolumeTrendBySitePriorityData: {} };

        case types.ROLLOVER_EXAMDATA_VOLUME_TREND_REQUEST:
            return { ...state, isLoadingRolloverExamDataVolumeTrend: true };
        case types.ROLLOVER_EXAMDATA_VOLUME_TREND_SUCCESS:
            return { ...state, isLoadingRolloverExamDataVolumeTrend: false, rolloverExamDataVolumeTrend: action.payload || {} };
        case types.ROLLOVER_EXAMDATA_VOLUME_TREND_FAILURE:
            return { ...state, isLoadingRolloverExamDataVolumeTrend: false, rolloverExamDataVolumeTrend: {} };

        case types.DELETE_SCHEDULING_FORECAST_REPORT_REQUEST:
            return { ...state, isDeletingSchedulingForecastReport: true };
        case types.DELETE_SCHEDULING_FORECAST_REPORT_SUCCESS:
            return { ...state, isDeletingSchedulingForecastReport: false, deleteSchedulingForecastReportResponse: action.payload || {} };
        case types.DELETE_SCHEDULING_FORECAST_REPORT_FAILURE:
            return { ...state, isDeletingSchedulingForecastReport: false, deleteSchedulingForecastReportResponse: {} };

        case types.GET_VOLUME_TREND_REPORTS_BY_ID_REQUEST:
            return { ...state, isLoadingVolumeTrendReportsById: true };
        case types.GET_VOLUME_TREND_REPORTS_BY_ID_SUCCESS:
            return { ...state, isLoadingVolumeTrendReportsById: false, volumeTrendReportsById: action.payload || {} };
        case types.GET_VOLUME_TREND_REPORTS_BY_ID_FAILURE:
            return { ...state, isLoadingVolumeTrendReportsById: false, volumeTrendReportsById: {} };

        case types.GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_REQUEST:
            return { ...state, isLoadingSchedulingForecastById: true, schedulingForecastByIdData: {} };
        case types.GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_SUCCESS:
            return { ...state, isLoadingSchedulingForecastById: false, schedulingForecastByIdData: action.payload || {} };
        case types.GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_FAILURE:
            return { ...state, isLoadingSchedulingForecastById: false, schedulingForecastByIdData: {} };

        case types.SAVE_VOLUME_TREND_REPORT_REQUEST:
            return { ...state, isSavingVolumeTrendReport: true };
        case types.SAVE_VOLUME_TREND_REPORT_SUCCESS:
            return { ...state, isSavingVolumeTrendReport: false, saveVolumeTrendReportResponse: action.payload || {} };
        case types.SAVE_VOLUME_TREND_REPORT_FAILURE:
            return { ...state, isSavingVolumeTrendReport: false, saveVolumeTrendReportResponse: {} };

        case types.DRAFT_SAVE_VOLUME_TREND_REPORT_REQUEST:
            return { ...state, isLoadingDraftSavingVolumeTrendReport: true, draftSaveVolumeTrendReportResponse: {} };
        case types.DRAFT_SAVE_VOLUME_TREND_REPORT_SUCCESS:
            return { ...state, isLoadingDraftSavingVolumeTrendReport: false, draftSaveVolumeTrendReportResponse: action.payload || {} };
        case types.DRAFT_SAVE_VOLUME_TREND_REPORT_FAILURE:
            return { ...state, isLoadingDraftSavingVolumeTrendReport: false, draftSaveVolumeTrendReportResponse: {} };

        case types.PUBLISH_VOLUME_TREND_REPORT_REQUEST:
            return { ...state, isLoadingPublishingVolumeTrendReport: true, publishVolumeTrendReportResponse: {} };
        case types.PUBLISH_VOLUME_TREND_REPORT_SUCCESS:
            return { ...state, isLoadingPublishingVolumeTrendReport: false, publishVolumeTrendReportResponse: action.payload || {} };
        case types.PUBLISH_VOLUME_TREND_REPORT_FAILURE:
            return { ...state, isLoadingPublishingVolumeTrendReport: false, publishVolumeTrendReportResponse: {} };

        case types.EXPORT_VOLUME_TREND_REPORT_REQUEST:
            return { ...state, isLoadingExportingVolumeTrendReport: true, exportVolumeTrendReportResponse: {} };
        case types.EXPORT_VOLUME_TREND_REPORT_SUCCESS:
            return { ...state, isLoadingExportingVolumeTrendReport: false, exportVolumeTrendReportResponse: action.payload || {} };
        case types.EXPORT_VOLUME_TREND_REPORT_FAILURE:
            return { ...state, isLoadingExportingVolumeTrendReport: false, exportVolumeTrendReportResponse: {} };

        case types.REPORT_NOTE_REQUEST:
            return { ...state, isLoadingReportNote: true, reportNoteData: {} };
        case types.REPORT_NOTE_SUCCESS:
            return { ...state, isLoadingReportNote: false, reportNoteData: action.payload || {} };
        case types.REPORT_NOTE_FAILURE:
            return { ...state, isLoadingReportNote: false, reportNoteData: {} };

        case types.SAVE_REPORT_NOTE_REQUEST:
            return { ...state, isLoadingSavingReportNote: true, saveReportNoteResponse: {} };
        case types.SAVE_REPORT_NOTE_SUCCESS:
            return { ...state, isLoadingSavingReportNote: false, saveReportNoteResponse: action.payload || {} };
        case types.SAVE_REPORT_NOTE_FAILURE:
            return { ...state, isLoadingSavingReportNote: false, saveReportNoteResponse: {} };
        
        case types.GET_EXAM_DATA_VOLUME_TREND_REQUEST:
            return { ...state, isLoadingVolumeTrend: true };
        case types.GET_EXAM_DATA_VOLUME_TREND_SUCCESS:
            return { ...state, isLoadingVolumeTrend: false, examDataVolumeTrend: action.payload || {} };
        case types.GET_EXAM_DATA_VOLUME_TREND_FAILURE:
            return { ...state, isLoadingVolumeTrend: false, examDataVolumeTrend: {} };

        case types.GET_VOLUME_TREND_DROPDOWNS_REQUEST:
            return { ...state, isLoadingVolumeTrendDropDowns: true };
        case types.GET_VOLUME_TREND_DROPDOWNS_SUCCESS:
            return { ...state, isLoadingVolumeTrendDropDowns: false, volumeTrendDropDownsData: action.payload || {} };
        case types.GET_VOLUME_TREND_DROPDOWNS_FAILURE:
            return { ...state, isLoadingVolumeTrendDropDowns: false, volumeTrendDropDownsData: {} };
        
        case types.RESET_ROLLOVER_EXAMDATA:
            return { ...state, rolloverExamDataVolumeTrend: {} };
        
        // Common cases
        case types.UPDATE_DEMAND_TABLE_REDUCER:
            return { ...state, ...action.payload };

        default:
            return state;
    }
}
export default VolumeTrendReportReducer;